import { _ as _defineProperty } from './defineProperty-2d1aa32d.js';
import { _ as _slicedToArray } from './slicedToArray-a6a95674.js';
import { _ as _objectWithoutProperties } from './objectWithoutProperties-2f896e18.js';
import { useState } from 'react';
import { c as classnames } from './index-4009c965.js';
import { TextColors, SecondaryColors } from '@picsart/design-system/foundation/colors';
import { FontSizes } from '@picsart/design-system/foundation/typography';
import { createUseStyles } from 'react-jss';
import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { defaultOutline } from './mixins/index.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function ownKeys$1(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles = createUseStyles({
  container: {
    alignItems: 'center',
    gap: Spacings.s8,
    display: 'flex'
  },
  switchBox: {
    position: 'relative',
    height: 24,
    width: 42
  },
  label: {
    fontWeight: FontWeights.semibold,
    fontSize: FontSizes.s16,
    color: TextColors.tint1,
    lineHeight: 1.5
  },
  slider: {
    border: "".concat(SecondaryColors.base["default"], " solid 1px"),
    borderRadius: CornerRadius.r24,
    position: 'absolute',
    inset: Spacings.s0,
    cursor: 'pointer',
    transition: '.4s',
    '&:before': {
      transform: function transform(_ref) {
        var checked = _ref.theme.checked;
        return checked ? "translateX(".concat(Spacings.s16, ")") : "translateX(".concat(Spacings.s0, ")");
      },
      boxShadow: '0px 2px 6px rgba(40, 43, 54, 0.16)',
      background: SecondaryColors.base["default"],
      borderRadius: CornerRadius.circle,
      position: 'absolute',
      left: Spacings.s4,
      transition: '.4s',
      content: '""',
      height: 16,
      width: 16,
      bottom: 3
    },
    '&:hover': {
      borderColor: SecondaryColors.base.action,
      '&:before': {
        background: SecondaryColors.base.action
      }
    }
  },
  checkbox: {
    opacity: 0,
    height: 0,
    width: 0,
    '&:focus + $slider': _objectSpread$1(_objectSpread$1({}, defaultOutline), {}, {
      transition: 'none'
    }),
    '&:focus:not(:focus-visible) + $slider': {
      outline: 'none'
    }
  }
}, {
  name: 'pa-monetization-switch'
});

var _excluded = ["prefixLabel", "suffixLabel", "dataTestId", "className", "disabled", "onChange", "checked"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function Switch(_ref) {
  var prefixLabel = _ref.prefixLabel,
    suffixLabel = _ref.suffixLabel,
    dataTestId = _ref.dataTestId,
    className = _ref.className,
    disabled = _ref.disabled,
    onChange = _ref.onChange,
    checked = _ref.checked,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(checked),
    _useState2 = _slicedToArray(_useState, 2),
    localChecked = _useState2[0],
    setLocalChecked = _useState2[1];
  var isChecked = checked === undefined ? localChecked : checked;
  var classes = useStyles({
    theme: {
      checked: checked
    }
  });
  var changeHandler = function changeHandler(e) {
    if (disabled) {
      return;
    }
    var _ref2 = e.target,
      checkedState = _ref2.checked;
    setLocalChecked(checkedState);
    onChange === null || onChange === void 0 || onChange(checkedState);
  };
  return /*#__PURE__*/jsxs("div", {
    className: classnames(classes.container, className),
    children: [prefixLabel && /*#__PURE__*/jsx("span", {
      dangerouslySetInnerHTML: {
        __html: prefixLabel
      },
      className: classes.label,
      "data-testid": "first-label"
    }), /*#__PURE__*/jsxs("label", {
      className: classes.switchBox,
      "data-testid": dataTestId,
      children: [/*#__PURE__*/jsx("input", _objectSpread({
        "data-pulse-name": isChecked ? 'on' : 'off',
        className: classes.checkbox,
        "data-testid": "switch-box",
        onChange: changeHandler,
        "data-pulse-clickable": true,
        checked: isChecked,
        type: "checkbox"
      }, props)), /*#__PURE__*/jsx("span", {
        className: classes.slider
      })]
    }), suffixLabel && /*#__PURE__*/jsx("span", {
      dangerouslySetInnerHTML: {
        __html: suffixLabel
      },
      className: classes.label,
      "data-test": "second-label"
    })]
  });
}

export { Switch as S };
//# sourceMappingURL=Switch-6eb87a1f.js.map
